export default __webpack_public_path__ + "static/mobile_top_background-3e4c4993b47ffe55e5a755a381ccca93.png";